import React from 'react';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';

function GoogleLoginComponent({config}) {
  const clientId = '407320487822-j1j1uquvtfghf8r57sf5f8a3gcvmjks5.apps.googleusercontent.com'; //config.GOOGLE_CLIENT_ID;

  const handleSuccess = (response) => {
    console.log('Google login successful:', response);
    const token = response.credential;

    // fetch(`${config.PY_API_URL}api/google-login`, {
    fetch(`${config.siteUrl}/wp-json/mm/v1/google-login-callback`, {

      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Server response =============:', data)
        if (data.success) {
          window.location.reload();
        }
      })
      .catch((error) => console.error('Error:', error));
  };

  const handleError = () => {
    console.log('Google login failed');
  };

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <GoogleLogin onSuccess={handleSuccess} onError={handleError} />
    </GoogleOAuthProvider>
  );
}

export default GoogleLoginComponent;
